import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { VaccineHistoryAnimalDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useGetVaccineHistoryList(animalId: string) {
  const { userFarm: farmId } = useAuth()

  return useQuery<VaccineHistoryAnimalDto[], Error>({
    queryKey: ['getVaccineHistoryList', farmId, animalId],
    queryFn: () => animalController.getVaccineHistoryByAnimal(farmId!, animalId),
    enabled: !!farmId && !!animalId
  })
}
